import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-1 w-50" }
const _hoisted_2 = { class: "pt-0" }
const _hoisted_3 = { class: "tabs-checkbox-container" }
const _hoisted_4 = { class: "section-wrapper" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "pl-3" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "d-flex align-items-center" }

import InfoSwitch from "@common/components/InfoSwitch.vue";
import { useLicenses } from "@common/composable/useRootStore";
import { computed, onMounted, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useActions, useState } from "vuex-composition-helpers";

//#region General
type TabVisibilitySettings = {
  IsTextAttributeSuggestionsEnabled: boolean;
  IsTableAttributeSuggestionsEnabled: boolean;
  IsGlobalAttributeSuggestionsEnabled: boolean;
  IsERPAttributeSuggestionsEnabled: boolean;
  IsShowingCataloguesTabEnabled: boolean;
  IsShowingClassificationTabEnabled: boolean;
  IsShowingERPTabEnabled: boolean;
  IsShowingGPSRTabEnabled: boolean;
  IsShowingGlobalAttributesTabEnabled: boolean;
  IsShowingKeywordsTabEnabled: boolean;
  IsShowingMasterDataTabEnabled: boolean;
  IsShowingMediaAssetsTabEnabled: boolean;
  IsShowingPricesTabEnabled: boolean;
  IsShowingReferencesTabEnabled: boolean;
  IsShowingTableAttributeTabEnabled: boolean;
  IsShowingTextAttributeTabEnabled: boolean;
  IsShowingTranslationTabEnabled: boolean;
  IsLiveEditEnabled: boolean;
  IsShowPricesEnabled: boolean;
  IsLiveEditPaginationEnabled: boolean;
  LiveEditArticlePagesize: number;
  ShowConfirmationDialogOnDragAndDrop: boolean;
  ShowConfirmationDialogIfAttributeGroupDiffers: boolean;
};
//#endregion

//#region Store
type ViewModel = {
  checked: boolean;
  intern_suggestionsEnabled: boolean;
  isJustOneTabEnabled: boolean;
  settings: TabVisibilitySettings;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralOptionsModal',
  setup(__props) {

const { t: $t } = useI18n();
const { userSettings } = useState(["userSettings"]);
const { saveUserSettings } = useActions(["saveUserSettings"]);
const { checkForLicensed } = useLicenses();
//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  checked: true,
  intern_suggestionsEnabled: true,
  isJustOneTabEnabled: false,
  settings: {
    IsTextAttributeSuggestionsEnabled: true,
    IsTableAttributeSuggestionsEnabled: true,
    IsGlobalAttributeSuggestionsEnabled: true,
    IsERPAttributeSuggestionsEnabled: true,
    IsShowingCataloguesTabEnabled: true,
    IsShowingClassificationTabEnabled: true,
    IsShowingERPTabEnabled: true,
    IsShowingGPSRTabEnabled: true,
    IsShowingGlobalAttributesTabEnabled: true,
    IsShowingKeywordsTabEnabled: true,
    IsShowingMasterDataTabEnabled: true,
    IsShowingMediaAssetsTabEnabled: true,
    IsShowingPricesTabEnabled: true,
    IsShowingReferencesTabEnabled: true,
    IsShowingTableAttributeTabEnabled: true,
    IsShowingTextAttributeTabEnabled: true,
    IsShowingTranslationTabEnabled: true,
    IsLiveEditEnabled: true,
    IsShowPricesEnabled: true,
    IsLiveEditPaginationEnabled: true,
    LiveEditArticlePagesize: 5,
    ShowConfirmationDialogOnDragAndDrop: true,
    ShowConfirmationDialogIfAttributeGroupDiffers: true
  }
});
//#endregion

//#region UserSettings
const ensureAtLeastOneTabEnabled = () => {
  const tabKeys: Array<keyof TabVisibilitySettings> = [
    "IsShowingCataloguesTabEnabled",
    "IsShowingClassificationTabEnabled",
    "IsShowingERPTabEnabled",
    "IsShowingGPSRTabEnabled",
    "IsShowingGlobalAttributesTabEnabled",
    "IsShowingKeywordsTabEnabled",
    "IsShowingMediaAssetsTabEnabled",
    "IsShowingPricesTabEnabled",
    "IsShowingReferencesTabEnabled",
    "IsShowingTableAttributeTabEnabled",
    "IsShowingTextAttributeTabEnabled",
    "IsShowingTranslationTabEnabled"
  ];

  const isAnyEnabled = tabKeys.some((key) => vm.settings[key]);

  if (!isAnyEnabled) {
    vm.isJustOneTabEnabled = true;
    vm.settings.IsShowingMasterDataTabEnabled = true;
  } else {
    vm.isJustOneTabEnabled = false;
  }
};

watch(
  () => vm.settings,
  (nv) => {
    checkForSuggestionEnabled(vm.settings);
    saveUserSettings(nv);
  },
  { deep: true }
);
watch(
  () => userSettings.value,
  (nv) => {
    if (!nv) return;

    Object.assign(vm.settings, {
      IsTextAttributeSuggestionsEnabled: nv.IsTextAttributeSuggestionsEnabled === true || nv.IsTextAttributeSuggestionsEnabled === "true",
      IsTableAttributeSuggestionsEnabled: nv.IsTableAttributeSuggestionsEnabled === true || nv.IsTableAttributeSuggestionsEnabled === "true",
      IsGlobalAttributeSuggestionsEnabled: nv.IsGlobalAttributeSuggestionsEnabled === true || nv.IsGlobalAttributeSuggestionsEnabled === "true",
      IsERPAttributeSuggestionsEnabled: nv.IsERPAttributeSuggestionsEnabled === true || nv.IsERPAttributeSuggestionsEnabled === "true",
      IsLiveEditEnabled: nv.IsLiveEditEnabled === true || nv.IsLiveEditEnabled === "true",
      IsShowPricesEnabled: nv.IsShowPricesEnabled === true || nv.IsShowPricesEnabled === "true",
      IsLiveEditPaginationEnabled: nv.IsLiveEditPaginationEnabled === true || nv.IsLiveEditPaginationEnabled === "true",
      LiveEditArticlePagesize: nv.LiveEditArticlePagesize,
      ShowConfirmationDialogOnDragAndDrop: nv.ShowConfirmationDialogOnDragAndDrop === true || nv.ShowConfirmationDialogOnDragAndDrop === "true",
      IsShowingCataloguesTabEnabled: nv.IsShowingCataloguesTabEnabled === true || nv.IsShowingCataloguesTabEnabled === "true",
      IsShowingClassificationTabEnabled: nv.IsShowingClassificationTabEnabled === true || nv.IsShowingClassificationTabEnabled === "true",
      IsShowingERPTabEnabled: nv.IsShowingERPTabEnabled === true || nv.IsShowingERPTabEnabled === "true",
      IsShowingGlobalAttributesTabEnabled: nv.IsShowingGlobalAttributesTabEnabled === true || nv.IsShowingGlobalAttributesTabEnabled === "true",
      IsShowingGPSRTabEnabled: nv.IsShowingGPSRTabEnabled === true || nv.IsShowingGPSRTabEnabled === "true",
      IsShowingKeywordsTabEnabled: nv.IsShowingKeywordsTabEnabled === true || nv.IsShowingKeywordsTabEnabled === "true",
      IsShowingMasterDataTabEnabled: nv.IsShowingMasterDataTabEnabled === true || nv.IsShowingMasterDataTabEnabled === "true",
      IsShowingMediaAssetsTabEnabled: nv.IsShowingMediaAssetsTabEnabled === true || nv.IsShowingMediaAssetsTabEnabled === "true",
      IsShowingPricesTabEnabled: nv.IsShowingPricesTabEnabled === true || nv.IsShowingPricesTabEnabled === "true",
      IsShowingReferencesTabEnabled: nv.IsShowingReferencesTabEnabled === true || nv.IsShowingReferencesTabEnabled === "true",
      IsShowingTableAttributeTabEnabled: nv.IsShowingTableAttributeTabEnabled === true || nv.IsShowingTableAttributeTabEnabled === "true",
      IsShowingTextAttributeTabEnabled: nv.IsShowingTextAttributeTabEnabled === true || nv.IsShowingTextAttributeTabEnabled === "true",
      IsShowingTranslationTabEnabled: nv.IsShowingTranslationTabEnabled === true || nv.IsShowingTranslationTabEnabled === "true",
      ShowConfirmationDialogIfAttributeGroupDiffers:
        nv.ShowConfirmationDialogIfAttributeGroupDiffers === true || nv.ShowConfirmationDialogIfAttributeGroupDiffers === "true"
    });
    ensureAtLeastOneTabEnabled();
  },
  { deep: true, immediate: true }
);
//#endregion

//#region Page/Suggestions
const suggestionsEnabled = computed({
  get: () => {
    return vm.intern_suggestionsEnabled;
  },
  set: (newValue) => {
    vm.intern_suggestionsEnabled = newValue;
    vm.settings.IsTextAttributeSuggestionsEnabled = newValue;
    vm.settings.IsTableAttributeSuggestionsEnabled = newValue;
    vm.settings.IsGlobalAttributeSuggestionsEnabled = newValue;
    vm.settings.IsERPAttributeSuggestionsEnabled = newValue;
  }
});

const checkForSuggestionEnabled = (settings: ViewModel["settings"]) => {
  if (
    settings.IsTextAttributeSuggestionsEnabled === false &&
    settings.IsTableAttributeSuggestionsEnabled === false &&
    settings.IsGlobalAttributeSuggestionsEnabled === false &&
    settings.IsERPAttributeSuggestionsEnabled === false
  ) {
    vm.intern_suggestionsEnabled = false;
  }
};

const articlePageSizes = computed(() => {
  const resultList = [];
  for (let i = 1; i <= 5; i++) {
    resultList.push({
      value: 5 * i,
      text: $t("articleCount", { field: 5 * i }).toString()
    });
  }
  return resultList;
});
//#endregion
onMounted(() => {
  checkForSuggestionEnabled(userSettings.value);
});

return (_ctx: any,_cache: any) => {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_tab = _resolveComponent("b-tab")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    id: "general-options-modal",
    title: _unref($t)('options'),
    "ok-only": "",
    "data-cy": "editor-general-option-modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_tabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_tab, {
            title: _unref($t)('menubar.general'),
            class: "p-2",
            "data-cy": "editor-general-options-tab"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.ShowConfirmationDialogOnDragAndDrop,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.settings.ShowConfirmationDialogOnDragAndDrop) = $event)),
                  inline: "",
                  "data-cy": "editor-drag-drop-confirm-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showConfirmationOnDragDrop")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.ShowConfirmationDialogIfAttributeGroupDiffers,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.settings.ShowConfirmationDialogIfAttributeGroupDiffers) = $event)),
                  inline: "",
                  "data-cy": "editor-ag-conflict-confirm-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showAttributeGroupConflictMessage")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_b_tab, {
            title: _unref($t)('menubar.liveedit'),
            class: "p-2",
            "data-cy": "editor-live-edit-options-tab"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsLiveEditEnabled,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vm.settings.IsLiveEditEnabled) = $event)),
                  inline: "",
                  "data-cy": "editor-live-edit-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.isLiveEditEnabled")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowPricesEnabled,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((vm.settings.IsShowPricesEnabled) = $event)),
                  inline: "",
                  "data-cy": "editor-live-edit-price-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showLiveEditPrices")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsLiveEditPaginationEnabled,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((vm.settings.IsLiveEditPaginationEnabled) = $event)),
                  inline: "",
                  "data-cy": "editor-live-edit-paging-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.enabledPagination")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("strong", _hoisted_2, _toDisplayString(_unref($t)("menubar.options.articlePerPage")), 1),
                _createVNode(_component_b_dropdown, {
                  class: "dropdown-default align-self-center mt-2",
                  disabled: !vm.settings.IsLiveEditPaginationEnabled
                }, {
                  "button-content": _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("articleCount", { field: vm.settings.LiveEditArticlePagesize })), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articlePageSizes.value, (articlePagesize) => {
                      return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: articlePagesize.value,
                        onClick: ($event: any) => (vm.settings.LiveEditArticlePagesize = articlePagesize.value)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(articlePagesize.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_b_tab, {
            title: _unref($t)('menubar.tabs'),
            class: "p-2 h-100",
            "data-cy": "editor-transltaion-options-tab"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingCataloguesTabEnabled,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((vm.settings.IsShowingCataloguesTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-catalogues-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showCatalogues")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingClassificationTabEnabled,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((vm.settings.IsShowingClassificationTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-classification-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showClassification")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingERPTabEnabled,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((vm.settings.IsShowingERPTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-erp-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showERP")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingGlobalAttributesTabEnabled,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((vm.settings.IsShowingGlobalAttributesTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-global-attributes-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showGlobalAttributes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_unref(checkForLicensed)('GPSR'))
                  ? (_openBlock(), _createBlock(_component_b_form_checkbox, {
                      key: 0,
                      modelValue: vm.settings.IsShowingGPSRTabEnabled,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((vm.settings.IsShowingGPSRTabEnabled) = $event)),
                      inline: "",
                      class: "checkbox-item align-items-center",
                      "data-cy": "editor-gpsr-enable-cbx"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showGPSR")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingKeywordsTabEnabled,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((vm.settings.IsShowingKeywordsTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-keywords-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showKeywords")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  disabled: vm.isJustOneTabEnabled,
                  modelValue: vm.settings.IsShowingMasterDataTabEnabled,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((vm.settings.IsShowingMasterDataTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-masterdata-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showMasterData")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingMediaAssetsTabEnabled,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((vm.settings.IsShowingMediaAssetsTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-media-assets-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showMediaAssets")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingPricesTabEnabled,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((vm.settings.IsShowingPricesTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-prices-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showPrices")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingReferencesTabEnabled,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((vm.settings.IsShowingReferencesTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-references-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showReferences")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingTableAttributeTabEnabled,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((vm.settings.IsShowingTableAttributeTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-table-attributes-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showTableAttributes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_b_form_checkbox, {
                  modelValue: vm.settings.IsShowingTextAttributeTabEnabled,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((vm.settings.IsShowingTextAttributeTabEnabled) = $event)),
                  inline: "",
                  class: "checkbox-item align-items-center",
                  "data-cy": "editor-text-attributes-enable-cbx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showTextAttributes")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_unref(checkForLicensed)('TranslationManager'))
                  ? (_openBlock(), _createBlock(_component_b_form_checkbox, {
                      key: 1,
                      modelValue: vm.settings.IsShowingTranslationTabEnabled,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((vm.settings.IsShowingTranslationTabEnabled) = $event)),
                      inline: "",
                      class: "checkbox-item align-items-center",
                      "data-cy": "editor-translation-enable-cbx"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("menubar.options.showTranslation")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_b_tab, {
            title: _unref($t)('menubar.suggestions'),
            class: "p-2",
            "data-cy": "editor-suggest-options-tab"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(InfoSwitch, {
                      size: "sm",
                      modelValue: suggestionsEnabled.value,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((suggestionsEnabled).value = $event)),
                      title: _unref($t)('AttributeSuggestions').toString(),
                      "data-cy": "editor-suggest-enable-cbx"
                    }, null, 8, ["modelValue", "title"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: vm.settings.IsTextAttributeSuggestionsEnabled,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((vm.settings.IsTextAttributeSuggestionsEnabled) = $event)),
                        disabled: !vm.intern_suggestionsEnabled,
                        inline: "",
                        "data-cy": "editor-suggest-text-enable-cbx"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($t)("text.name")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: vm.settings.IsTableAttributeSuggestionsEnabled,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((vm.settings.IsTableAttributeSuggestionsEnabled) = $event)),
                        disabled: !vm.intern_suggestionsEnabled,
                        inline: "",
                        "data-cy": "editor-suggest-table-enable-cbx"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($t)("table.name")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: vm.settings.IsGlobalAttributeSuggestionsEnabled,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((vm.settings.IsGlobalAttributeSuggestionsEnabled) = $event)),
                        disabled: !vm.intern_suggestionsEnabled,
                        inline: "",
                        "data-cy": "editor-suggest-global-enable-cbx"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($t)("global.name")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: vm.settings.IsERPAttributeSuggestionsEnabled,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((vm.settings.IsERPAttributeSuggestionsEnabled) = $event)),
                        disabled: !vm.intern_suggestionsEnabled,
                        inline: "",
                        "data-cy": "editor-suggest-erp-enable-cbx"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($t)("erp.name")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})